export default function displayPhone(phone) {
  if (!phone) return "";

  return `(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7, 11)}`;
}
